<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="kgd-price-sidebar"
    bg-variant="white"
    right
    lazy
    backdrop
    no-close-on-backdrop
    no-header
    @shown="getData"
    @hidden="resetSidebarData"
    shadow
    :width="sidebarWidth"
    ref="kgdPriceSidebar"
    :title="addPrice ? 'Добавление прайса Калининград' : 'Редактирование прайса Калининград'">
    <template v-slot:default="{ hide }">
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <b-form @submit.stop.prevent="saveFormData" autocomplete="off">
          <h2 v-if="addPrice" class="my-4">Добавление прайса Калининград</h2>
          <h2 v-else class="my-4">Редактирование прайса Калининград</h2>
          <b-row>
            <b-col>
              <b-form-group
                label="Месяц начала действия прайса"
                label-for="dateStart"
                label-class="mf-label"
                class="my-3">
                <a-month-picker
                  class="mr-3"
                  size="large"
                  v-model="dateStart"
                  :disabled="disabled"
                  format="MM/YYYY"
                  placeholder="Дата"/>
              </b-form-group>
            </b-col>
          </b-row>
          <h4 class="form-title">Пакеты</h4>
          <b-row>
            <b-col xl="6">
              <b-table
                id="data_table"
                ref="priceKgd"
                hover
                :fields="fields"
                :items="modelPackages"
              >
                <template v-slot:cell(packageName)="data">
                  <b>{{ data.item.packageName }}</b>
                </template>
                <template v-slot:cell(rangeDefault)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'Портал'"
                    :invalid-feedback="getError('Портал')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeDefault0-input"
                      name="Портал"
                      v-validate="priceValidation"
                      data-vv-as="Портал"
                      v-model="modelPackages[0].rangeDefault0"
                      :disabled="disabled"
                      :state="validateState('Портал')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '10 пакетов'"
                    :invalid-feedback="getError('10 пакетов')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeDefault1-input"
                      name="10 пакетов"
                      v-validate="priceValidation"
                      data-vv-as="10 пакетов"
                      v-model="modelPackages[1].rangeDefault1"
                      :disabled="disabled"
                      :state="validateState('10 пакетов')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '20 пакетов'"
                    :invalid-feedback="getError('20 пакетов')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeDefault2-input"
                      name="20 пакетов"
                      v-validate="priceValidation"
                      data-vv-as="20 пакетов"
                      v-model="modelPackages[2].rangeDefault2"
                      :disabled="disabled"
                      :state="validateState('20 пакетов')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '50 пакетов'"
                    :invalid-feedback="getError('50 пакетов')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeDefault3-input"
                      name="50 пакетов"
                      v-validate="priceValidation"
                      data-vv-as="50 пакетов"
                      v-model="modelPackages[3].rangeDefault3"
                      :disabled="disabled"
                      :state="validateState('50 пакетов')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '100 пакетов'"
                    :invalid-feedback="getError('100 пакетов')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeDefault4-input"
                      name="100 пакетов"
                      v-validate="priceValidation"
                      data-vv-as="100 пакетов"
                      v-model="modelPackages[4].rangeDefault4"
                      :disabled="disabled"
                      :state="validateState('100 пакетов')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '200 пакетов'"
                    :invalid-feedback="getError('200 пакетов')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeDefault5-input"
                      name="200 пакетов"
                      v-validate="priceValidation"
                      @change="changeNextRange"
                      data-vv-as="200 пакетов"
                      v-model="modelPackages[5].rangeDefault5"
                      :disabled="disabled"
                      :state="validateState('200 пакетов')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '200+ пакетов'"
                    :invalid-feedback="getError('200+ пакетов')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeDefault6-input"
                      name="200+ пакетов"
                      :disabled="true"
                      v-validate="priceValidation"
                      data-vv-as="200+ пакетов"
                      v-model="modelPackages[6].rangeDefault6"
                      :state="validateState('200+ пакетов')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col xl="2" class="d-flex align-items-end">
              <div style="margin-bottom: 23px">
                <b-form-group
                  label="Цена пакета с превышения"
                  label-class="price-over"
                  label-for="priceOverStandart"
                  :invalid-feedback="getError('Цена пакета с превышения')"
                  style="margin-bottom: 0">
                  <b-form-input
                    id="priceOverStandart"
                    name="Цена пакета с превышения"
                    v-validate="priceValidation"
                    data-vv-as="Цена пакета с превышения"
                    v-model="priceOver"
                    :disabled="disabled"
                    :state="validateState('Цена пакета с превышения')"
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-col>
            <b-col xl="2">
              <b-table
                id="data_table"
                ref="priceKgd"
                hover
                :fields="fieldsRecalc"
                :items="modelRecalc"
              >
                <template v-slot:cell(rangeRecalc)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'Портал'"
                    :invalid-feedback="getError('Портал пересчет')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeRecalc0-input"
                      name="Портал пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Портал пересчет"
                      v-model="modelRecalc[0].rangeRecalc0"
                      :disabled="disabled"
                      :state="validateState('Портал пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '10 пакетов'"
                    :invalid-feedback="getError('10 пакетов пересчет')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeRecalc1-input"
                      name="10 пакетов пересчет"
                      v-validate="priceValidation"
                      data-vv-as="10 пакетов пересчет"
                      v-model="modelRecalc[1].rangeRecalc1"
                      :disabled="disabled"
                      :state="validateState('10 пакетов пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '20 пакетов'"
                    :invalid-feedback="getError('20 пакетов пересчет')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeRecalc2-input"
                      name="20 пакетов пересчет"
                      v-validate="priceValidation"
                      data-vv-as="20 пакетов пересчет"
                      v-model="modelRecalc[2].rangeRecalc2"
                      :disabled="disabled"
                      :state="validateState('20 пакетов пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '50 пакетов'"
                    :invalid-feedback="getError('50 пакетов пересчет')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeRecalc3-input"
                      name="50 пакетов пересчет"
                      v-validate="priceValidation"
                      data-vv-as="50 пакетов пересчет"
                      v-model="modelRecalc[3].rangeRecalc3"
                      :disabled="disabled"
                      :state="validateState('50 пакетов пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '100 пакетов'"
                    :invalid-feedback="getError('100 пакетов пересчет')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeRecalc4-input"
                      name="100 пакетов пересчет"
                      v-validate="priceValidation"
                      data-vv-as="100 пакетов пересчет"
                      v-model="modelRecalc[4].rangeRecalc4"
                      :disabled="disabled"
                      :state="validateState('100 пакетов пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '200 пакетов'"
                    :invalid-feedback="getError('200 пакетов пересчет')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeRecalc5-input"
                      name="200 пакетов пересчет"
                      v-validate="priceValidation"
                      @change="changeNextRangeRecalc"
                      data-vv-as="200 пакетов пересчет"
                      v-model="modelRecalc[5].rangeRecalc5"
                      :disabled="disabled"
                      :state="validateState('200 пакетов пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === '200+ пакетов'"
                    :invalid-feedback="getError('200+ пакетов пересчет')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="rangeRecalc6-input"
                      name="200+ пакетов пересчет"
                      :disabled="true"
                      v-validate="priceValidation"
                      data-vv-as="200+ пакетов пересчет"
                      v-model="modelRecalc[6].rangeRecalc6"
                      :state="validateState('200+ пакетов пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col xl="2" class="d-flex align-items-end">
              <div style="margin-bottom: 23px">
                <b-form-group
                  label="Цена пакета с превышения"
                  label-class="price-over"
                  label-for="priceOverStandartRecalc"
                  :invalid-feedback="getError('Цена пакета с превышения пересчет')"
                  style="margin-bottom: 0">
                  <b-form-input
                    id="priceOverStandartRecalc"
                    name="Цена пакета с превышения пересчет"
                    v-validate="priceValidation"
                    data-vv-as="Цена пакета с превышения пересчет"
                    v-model="priceOverRecalc"
                    :disabled="disabled"
                    :state="validateState('Цена пакета с превышения пересчет')"
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <h4 class="form-title">Вознаграждение</h4>
          <b-row>
            <b-col xl="3">
              <b-table
                id="data_table"
                hover
                ref="compensation"
                :fields="compensationFields"
                :items="compensationModel"
              >
                <template v-slot:cell(type)="data">
                  <b>{{ data.item.type }}</b>
                </template>
                <template v-slot:cell(percent)="data">
                  <b-form-group
                    v-if="data.item.type === 'Пакеты'"
                    :invalid-feedback="getError('Пакеты')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="percentPackages-input"
                      name="Пакеты"
                      v-validate="priceValidation"
                      data-vv-as="Пакеты"
                      v-model="compensationModel[0].percentPackages"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Пакеты')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.type === 'Тариф'"
                    :invalid-feedback="getError('Тариф')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="percentLicense-input"
                      name="Тариф"
                      v-validate="priceValidation"
                      data-vv-as="Тариф"
                      v-model="compensationModel[1].percentLicense"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Тариф')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col class="d-flex align-items-center">
              <b-button :disabled="disabled" @click="recalcPrices" variant="outline-primary" v-b-tooltip title="Рассчитать" class="ml-4"><i class="fas fa-calculator"></i></b-button>
            </b-col>
          </b-row>
          <b-row class="mb-3 mt-3">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12">
              <div class="d-md-flex d-lg-flex align-items-start">
                <b-button
                  :disabled="veeErrors.any() || (Boolean(dateStart) === false || disabled)"
                  variant="success"
                  type="submit"
                  class="btn-action-success mr-3 mb-2">
                  <span v-if="addPrice">Добавить прайс</span>
                  <span v-else>Изменить прайс</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validation } from '../modalForms/validation'
import moment from 'moment'

export default {
  name: 'AddKgdPrice',
  components: {},
  props: ['addPrice', 'startMonth', 'startYear', 'disabled'],
  mixins: [validation],
  data () {
    return {
      billingAlias: 'dyn_mc_disc',
      sidebarWidth: '',
      dateStart: null,
      fields: [
        { key: 'packageName', label: 'Наименование тарифа' },
        { key: 'range', label: 'Количество пакетов' },
        { key: 'rangeDefault', label: 'Стоимость', thStyle: 'width: 30%' }
      ],
      fieldsRecalc: [
        { key: 'rangeRecalc', label: 'Вознаграждение' }
      ],
      modelPackages: [
        { packageName: 'Портал', range: '0', rangeDefault0: null },
        { packageName: '10 пакетов', range: '1-10', rangeDefault1: null },
        { packageName: '20 пакетов', range: '11-20', rangeDefault2: null },
        { packageName: '50 пакетов', range: '21-50', rangeDefault3: null },
        { packageName: '100 пакетов', range: '51-100', rangeDefault4: null },
        { packageName: '200 пакетов', range: '101-200', rangeDefault5: null },
        { packageName: '200+ пакетов', range: '200+', rangeDefault6: null }
      ],
      modelRecalc: [
        { packageName: 'Портал', range: '0', rangeRecalc0: null },
        { packageName: '10 пакетов', range: '1-10', rangeRecalc1: null },
        { packageName: '20 пакетов', range: '11-20', rangeRecalc2: null },
        { packageName: '50 пакетов', range: '21-50', rangeRecalc3: null },
        { packageName: '100 пакетов', range: '51-100', rangeRecalc4: null },
        { packageName: '200 пакетов', range: '101-200', rangeRecalc5: null },
        { packageName: '200+ пакетов', range: '200+', rangeRecalc6: null }
      ],
      priceOverRecalc: null,
      priceOver: null,
      compensationFields: [
        { key: 'type', label: 'Тип' },
        { key: 'percent', label: 'Процент' }
      ],
      compensationModel: [
        { type: 'Пакеты', percentPackages: null },
        { type: 'Тариф', percentLicense: null }
      ],
      freezeModelPackages: null,
      freezeModelRecalc: null,
      oldStartMonth: null,
      oldStartYear: null
    }
  },
  mounted () {
    this.calcSidebarWidth()
  },
  computed: {
    ...mapState(
      {
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        dealerPriceData: state => state.dealers.dealerPriceData
      }
    )
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    getData () {
      this.freezeModelPackages = JSON.parse(JSON.stringify(this.modelPackages))
      this.freezeModelRecalc = JSON.parse(JSON.stringify(this.modelRecalc))
      if (!this.addPrice) {
        this.getDealerPrice({ month: this.startMonth, year: this.startYear, id: this.$route.params.id, billing_alias: this.billingAlias }).then(
          () => {
            console.log(this.dealerPriceData)
            this.priceOver = this.dealerPriceData.packages[0].client_points_cost
            this.priceOverRecalc = this.dealerPriceData.packages[0].daobit_points_cost
            this.dealerPriceData.lycense.map((item) => {
              if (item.price_position === 'tpp_discrete_portal') {
                this.modelPackages[0].rangeDefault0 = item.client_price
                this.modelRecalc[0].rangeRecalc0 = item.daobit_price
              }
              if (item.price_position === 'tpp_discrete_packages_10') {
                this.modelPackages[1].rangeDefault1 = item.client_price
                this.modelRecalc[1].rangeRecalc1 = item.daobit_price
              }
              if (item.price_position === 'tpp_discrete_packages_20') {
                this.modelPackages[2].rangeDefault2 = item.client_price
                this.modelRecalc[2].rangeRecalc2 = item.daobit_price
              }
              if (item.price_position === 'tpp_discrete_packages_50') {
                this.modelPackages[3].rangeDefault3 = item.client_price
                this.modelRecalc[3].rangeRecalc3 = item.daobit_price
              }
              if (item.price_position === 'tpp_discrete_packages_100') {
                this.modelPackages[4].rangeDefault4 = item.client_price
                this.modelRecalc[4].rangeRecalc4 = item.daobit_price
              }
              if (item.price_position === 'tpp_discrete_packages_200') {
                this.modelPackages[5].rangeDefault5 = item.client_price
                this.modelRecalc[5].rangeRecalc5 = item.daobit_price
                this.modelPackages[6].rangeDefault6 = item.client_price
                this.modelRecalc[6].rangeRecalc6 = item.daobit_price
              }
            })
            this.calcPackagesPercent(this.dealerPriceData.packages[0])
            this.calcLicensePercent()
            const dt = this.startYear + '-' + (this.startMonth.length > 0 ? this.startMonth : ('0' + this.startMonth)) + '-' + '01'
            this.dateStart = moment(dt)
            this.oldStartMonth = this.startMonth
            this.oldStartYear = this.startYear
          }
        )
      } else {
        this.dateStart = null
      }
    },
    calcPackagesPercent (item) {
      this.compensationModel[0].percentPackages = parseFloat((item.daobit_points_cost * 100 / item.client_points_cost).toFixed(2))
    },
    calcLicensePercent () {
      const percents = []
      this.dealerPriceData.lycense.map((item) => {
        percents.push(parseFloat((item.daobit_price * 100 / item.client_price).toFixed(2)))
        percents.push(parseFloat((item.daobit_additional_account_price * 100 / item.client_additional_account_price).toFixed(2)))
      })
      const counts = {}
      percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
      this.compensationModel[1].percentLicense = Object.keys(counts)[0]
    },
    changeNextRange (val) {
      this.modelPackages[6].rangeDefault6 = val
    },
    changeNextRangeRecalc (val) {
      this.modelRecalc[6].rangeRecalc6 = val
    },
    percentage (percent, total) {
      return ((percent / 100) * total).toFixed(2)
    },
    recalcPrices () {
      this.modelPackages.map((item, index) => {
        const defaultKeys = Object.keys(item)
        const recalcKeys = Object.keys(this.modelRecalc[index])
        for (let i = 0; i < defaultKeys.length; i++) {
          if (i > 0) {
            if ((this.modelPackages[index][defaultKeys[i]] !== '') && (this.modelPackages[index][defaultKeys[i]] !== null)) {
              this.modelRecalc[index][recalcKeys[i]] = parseFloat(this.percentage(this.compensationModel[1].percentLicense, this.modelPackages[index][defaultKeys[i]]))
            }
          }
        }
      })
      this.priceOverRecalc = parseFloat(this.percentage(this.compensationModel[0].percentPackages, this.priceOver))
    },
    calcSidebarWidth () {
      if (this.largeDesktop) {
        this.sidebarWidth = '70%'
      } else if (this.desktop) {
        this.sidebarWidth = '100%'
      } else if (this.mobile || this.tablet) {
        this.sidebarWidth = '100%'
      }
    },
    saveFormData () {
      const data = {
        year: null,
        month: null,
        year_new: null,
        month_new: null,
        // percent_lycense: this.compensationModel[1].percentLicense ? parseFloat(this.compensationModel[1].percentLicense) : null,
        // percent_packages: this.compensationModel[0].percentPackages ? parseFloat(this.compensationModel[0].percentPackages) : null,
        lycense: [
          {
            price_position: 'tpp_discrete_portal',
            client_price: Object.values(this.modelPackages[0]).filter((item, index) => index === 2).map((i) => parseFloat(i))[0],
            daobit_price: Object.values(this.modelRecalc[0]).filter((item, index) => index === 2)[0]
          },
          {
            price_position: 'tpp_discrete_packages_10',
            client_price: Object.values(this.modelPackages[1]).filter((item, index) => index === 2).map((i) => parseFloat(i))[0],
            daobit_price: Object.values(this.modelRecalc[1]).filter((item, index) => index === 2)[0]
          },
          {
            price_position: 'tpp_discrete_packages_20',
            client_price: Object.values(this.modelPackages[2]).filter((item, index) => index === 2).map((i) => parseFloat(i))[0],
            daobit_price: Object.values(this.modelRecalc[2]).filter((item, index) => index === 2)[0]
          },
          {
            price_position: 'tpp_discrete_packages_50',
            client_price: Object.values(this.modelPackages[3]).filter((item, index) => index === 2).map((i) => parseFloat(i))[0],
            daobit_price: Object.values(this.modelRecalc[3]).filter((item, index) => index === 2)[0]
          },
          {
            price_position: 'tpp_discrete_packages_100',
            client_price: Object.values(this.modelPackages[4]).filter((item, index) => index === 2).map((i) => parseFloat(i))[0],
            daobit_price: Object.values(this.modelRecalc[4]).filter((item, index) => index === 2)[0]
          },
          {
            price_position: 'tpp_discrete_packages_200',
            client_price: Object.values(this.modelPackages[5]).filter((item, index) => index === 2).map((i) => parseFloat(i))[0],
            daobit_price: Object.values(this.modelRecalc[5]).filter((item, index) => index === 2)[0]
          }
        ],
        packages: [
          {
            message_price_position_alias: 'pp_message',
            client_points_cost: parseFloat(this.priceOver),
            daobit_points_cost: parseFloat(this.priceOverRecalc)
          }
        ]
      }

      const year = this.dateStart.toDate().getFullYear()
      const month = this.dateStart.toDate().getMonth() + 1

      if (this.addPrice) {
        data.year = year
        data.month = month
      } else {
        data.year_new = year
        data.month_new = month
        data.year = this.oldStartYear
        data.month = this.oldStartMonth
      }
      if (this.addPrice) {
        this.saveDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          (response) => {
            console.log('response ', response)
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.kgdPriceSidebar.hide()
          }
        )
      } else {
        this.updateDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          () => {
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.kgdPriceSidebar.hide()
          }
        )
      }
    },
    resetSidebarData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
      setTimeout(() => {
        this.modelPackages = this.freezeModelPackages
        this.modelRecalc = this.freezeModelRecalc
        this.priceOverRecalc = null
        this.priceOver = null
        this.setPrice(null)
      }, 200)
    },
    ...mapActions('dealers', [
      'saveDealerPrice',
      'getDealerPrice',
      'updateDealerPrice',
      'getDealerPricesData'
    ]),
    ...mapMutations('dealers', [
      'setPrice'
    ])
  }
}
</script>

<style scoped>

</style>
